import React from "react";

import { Heading, type HeadingLevel } from "@dip/helsecore/src/components/shared/Heading/Heading";

const MIN_HEADING_LEVEL = 1;
const MAX_HEADING_LEVEL = 5;

export function toHeadingLevel(level: number): HeadingLevel {
  const clampedLevel = Math.min(Math.max(Math.floor(level), MIN_HEADING_LEVEL), MAX_HEADING_LEVEL);
  return `h${clampedLevel}` as HeadingLevel;
}

type PdfHeadingProps = {
  level: number;
  children?: React.ReactNode;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
};

export default function PdfHeading(props: Readonly<PdfHeadingProps>) {
  const {
    level, children, id, className, style
  } = props;

  // Empty override keeps the print stylesheet in charge instead of helsecore's web Tailwind sizes.
  return (
    <Heading
      headingLevel={toHeadingLevel(level)}
      overrideDefaultStyle=""
      id={id}
      className={className}
      style={style}
    >
      {children}
    </Heading>
  );
}
